/* eslint func-names: ["error", "never"] */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable global-require */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-use-before-define */
/* eslint-disable no-case-declarations */
/* eslint-disable no-redeclare */
/* eslint-disable no-unreachable */

const _merge = require('merge');

module.exports = function (h, modules, classes, slots) {
  let filterId = null;
  let ddpId = null;
  let perpageId = null;
  let perpageValues = null;
  let genericFilter = null;
  let perpage = null;
  let dropdownPagination = null;
  let columnsDropdown = null;
  let footerHeadings = null;
  let tableTop = null;
  let shouldShowTop;

  // const route = this.$parent.$route;
  const url = this.$options.parent.options.url;

  // console.log('switch.url', url);

  switch (true) {
    case url === '/api/travel-plans':

      return <div class={`VueTables VueTables--${this.source}`}>
      <div class="row">
      {modules.rows(classes)}
      </div>
      {modules.pagination(_merge(classes.pagination, {
        wrapper: `${classes.row} ${classes.column} ${classes.contentCenter}`,
        nav: classes.center,
        count: `${classes.center} ${classes.column}`,
      }))}
      </div>;

      break;

    case url === '/api/profiles/show':
      return <div>
        <div class="row">
        {modules.rows(classes)}
        </div>
        {modules.pagination(_merge(classes.pagination, {
          wrapper: `${classes.row} ${classes.column} ${classes.contentCenter}`,
          nav: classes.center,
          count: `${classes.center} ${classes.column}`,
        }))}
        </div>;

      break;

    // grid
    case url === '/api/profiles/search':
    case url === '/api/profiles/starred':
    case url === '/api/profiles/matches':
    case url === '/api/profiles/received':
    case url === '/api/profiles/sent':

      return <div class={`VueTables VueTables--${this.source}`}>
      <div class="row">
        <div class="form-group form-inline pull-left VueTables__search">
          {modules.normalFilter(classes, filterId)}
        </div>
      </div>
      <div class="row row-flex">
      {modules.rows(classes)}
      </div>
      {modules.pagination(_merge(classes.pagination, {
        wrapper: `${classes.row} ${classes.column} ${classes.contentCenter}`,
        nav: classes.center,
        count: `${classes.center} ${classes.column}`,
      }))}
      </div>;

      break;

    default:

      filterId = `VueTables__search_${this.id}`;
      ddpId = `VueTables__dropdown-pagination_${this.id}`;
      perpageId = `VueTables__limit_${this.id}`;
      perpageValues = require('./modules-uncompiled/per-page-values').call(this, h);

      genericFilter = this.hasGenericFilter
        ? <div class="VueTables__search-field">
    <label for={filterId} class={classes.label}>{this.display('filter')}</label>
    {modules.normalFilter(classes, filterId)}
    </div> : '';

      perpage = perpageValues.length > 1 ? <div class="VueTables__limit-field">
    <label class={classes.label} for={perpageId}>{this.display('limit')}</label>
    {modules.perPage(perpageValues, classes.select, perpageId)}
    </div> : '';

      dropdownPagination = this.opts.pagination && this.opts.pagination.dropdown
        ? <div class="VueTables__pagination-wrapper">
    <div class={`${classes.field} ${classes.inline} ${classes.right} VueTables__dropdown-pagination`}
    v-show={this.totalPages > 1}
    >
    <label for={ddpId}>{this.display('page')}</label>
    {modules.dropdownPagination(classes.select, ddpId)}
    </div>
    </div> : '';

      columnsDropdown = this.opts.columnsDropdown
        ? <div class="VueTables__columns-dropdown-wrapper">
    {modules.columnsDropdown(classes)}
    </div> : '';

      footerHeadings = this.opts.footerHeadings
        ? <tfoot><tr>{modules.headings(classes.right)}</tr></tfoot> : '';

      shouldShowTop = genericFilter
      || perpage
      || dropdownPagination
      || columnsDropdown
      || slots.beforeFilter
      || slots.afterFilter
      || slots.beforeLimit
      || slots.afterLimit;

      tableTop = <div class={classes.row} v-show={shouldShowTop}>
      <div class={classes.column}>
      <div class={`${classes.field} ${classes.inline} ${classes.left} VueTables__search`}>
      {slots.beforeFilter}
      {genericFilter}
      {slots.afterFilter}
      </div>
      <div class={`${classes.field} ${classes.inline} ${classes.right} VueTables__limit`}>
      {slots.beforeLimit}
      {perpage}
      {slots.afterLimit}
      </div>
      {dropdownPagination}
      {columnsDropdown}
      </div>
      </div>;

      return <div class={`VueTables VueTables--${this.source}`}>
      {tableTop}
      {slots.beforeTable}
      <div class="table-responsive">
      <table class={`VueTables__table ${this.opts.skin ? this.opts.skin : classes.table}`}>
      <thead>
      <tr>
      {modules.headings(classes.right)}
      </tr>
      {slots.beforeFilters}
      {modules.columnFilters(classes)}
      {slots.afterFilters}
      </thead>
      {footerHeadings}
      {slots.beforeBody}
      <tbody>
      {slots.prependBody}
      {modules.rows(classes)}
      {slots.appendBody}
      </tbody>
      {slots.afterBody}
      </table>
      </div>
      {slots.afterTable}
      {modules.pagination(_merge(classes.pagination, {
        wrapper: `${classes.row} ${classes.column} ${classes.contentCenter}`,
        nav: classes.center,
        count: `${classes.center} ${classes.column}`,
      }))}
      {modules.dropdownPaginationCount()}

      </div>;

      break;
  }
};
